(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('engraving-personalizer')) return;

  // ~100 curated, engraving-friendly Google fonts (clean scripts, serifs, sans).
  // Decorative/hairline/symbol fonts are intentionally excluded; they engrave poorly.
  var FONTS = [
    // Scripts / calligraphy
    'Great Vibes', 'Allura', 'Alex Brush', 'Dancing Script', 'Sacramento', 'Satisfy',
    'Pacifico', 'Tangerine', 'Pinyon Script', 'Parisienne', 'Yellowtail', 'Kaushan Script',
    'Courgette', 'Niconne', 'Cookie', 'Petit Formal Script', 'Marck Script', 'Norican',
    'Clicker Script', 'Mr Dafoe', 'Carattere', 'Rouge Script', 'Italianno', 'Engagement',
    'Bilbo', 'Mrs Saint Delafield', 'Herr Von Muellerhoff', 'Lovers Quarrel',
    'Monsieur La Doulaise', 'Mr De Haviland', 'Style Script', 'Ephesis', 'Birthstone',
    'Whisper', 'Meddon',
    // Handwritten
    'Caveat', 'Shadows Into Light', 'Indie Flower', 'Amatic SC', 'Permanent Marker',
    'Kalam', 'Patrick Hand', 'Gochi Hand', 'Architects Daughter', 'Reenie Beanie',
    'Nanum Pen Script', 'Homemade Apple',
    // Serif
    'Playfair Display', 'Cormorant Garamond', 'EB Garamond', 'Cormorant', 'Cinzel',
    'Cinzel Decorative', 'Libre Baskerville', 'Crimson Text', 'Crimson Pro', 'Abril Fatface',
    'DM Serif Display', 'Prata', 'Marcellus', 'Marcellus SC', 'Italiana', 'Spectral',
    'Vollkorn', 'Alegreya', 'Lora', 'PT Serif', 'Bodoni Moda', 'Yeseva One', 'Merriweather',
    'Cardo', 'Sorts Mill Goudy', 'Old Standard TT', 'Forum', 'Tinos', 'Gilda Display',
    'Bellefair',
    // Sans
    'Montserrat', 'Poppins', 'Raleway', 'Josefin Sans', 'Quicksand', 'Comfortaa', 'Oswald',
    'Bebas Neue', 'Anton', 'Archivo', 'Questrial', 'Jost', 'Sora', 'Nunito', 'Rubik',
    'Work Sans', 'Manrope', 'DM Sans', 'Mulish', 'Cabin', 'Tenor Sans', 'Julius Sans One',
    'Maven Pro'
  ];

  // The script group (first block above) previews at 1.3x, like the house script.
  var SCRIPT_FONTS = FONTS.slice(0, FONTS.indexOf('Caveat'));

  // Per-shape text fit: w = width fill per line (line1, line2, line3+), h = max
  // share of the tag height the stacked text may use. Tuned to each silhouette's
  // usable engraving area (heart = upper lobes, bone = middle shaft).
  var FIT = {
    round:   { w: [0.75, 0.7, 0.65], h: 0.75 },
    rounded: { w: [0.8, 0.75, 0.7], h: 0.8 },
    heart:   { w: [0.52, 0.48, 0.44], h: 0.42 },
    bone:    { w: [0.82, 0.74, 0.68], h: 0.5 }
  };

  var ALIGN_LABEL = { left: 'Left', center: 'Center', right: 'Right' };
  var SIZE_LABEL = { s: 'Small', m: 'Medium', l: 'Large' };

  // Shared with engraving-preview.js so each Google family is requested once per page.
  var loaded = window.BEEngravingFonts = window.BEEngravingFonts || {};
  function loadFonts(families) {
    var batch = [];
    families.forEach(function (f) {
      if (f && !loaded[f]) { loaded[f] = true; batch.push(f); }
    });
    for (var i = 0; i < batch.length; i += 18) {
      var group = batch.slice(i, i + 18);
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?' +
        group.map(function (f) {
          return 'family=' + encodeURIComponent(f).replace(/%20/g, '+');
        }).join('&') + '&display=swap';
      document.head.appendChild(link);
    }
  }

  function clampText(value, maxLines, maxChars) {
    var lines = value.replace(/\r/g, '').split('\n').slice(0, maxLines);
    lines = lines.map(function (l) { return l.slice(0, maxChars); });
    return lines.join('\n');
  }

  function scaleFor(family) {
    if (family === 'EB Garamond') return 1.08;
    return SCRIPT_FONTS.indexOf(family) !== -1 ? 1.3 : 1;
  }

  function normAlign(a) {
    a = String(a || '').toLowerCase();
    return ALIGN_LABEL[a] ? a : '';
  }

  function normSize(s) {
    s = String(s || '').toLowerCase();
    if (SIZE_LABEL[s]) return s;
    return { small: 's', medium: 'm', large: 'l' }[s] || '';
  }

  // Query-param prefill (?front=&back=&font=&align=&size=&side=). Same shape as
  // window.BEEngraving.readParams(), kept local so pet-tag pages need no extra JS.
  function readParams() {
    var out = {};
    if (!('URLSearchParams' in window)) return out;
    var sp = new URLSearchParams(window.location.search);
    if (sp.has('front')) out.front = sp.get('front').replace(/\r\n?/g, '\n');
    if (sp.has('back')) out.back = sp.get('back').replace(/\r\n?/g, '\n');
    if (sp.get('font')) out.fontValue = sp.get('font');
    if (normAlign(sp.get('align'))) out.align = normAlign(sp.get('align'));
    if (normSize(sp.get('size'))) out.size = normSize(sp.get('size'));
    var side = String(sp.get('side') || '').toLowerCase();
    if (side === 'front' || side === 'back') out.side = side;
    if (parseInt(sp.get('tally'), 10) > 0) out.tally = parseInt(sp.get('tally'), 10);
    if (sp.has('name')) out.name = sp.get('name');
    var heart = String(sp.get('heart') || '').toLowerCase();
    if (heart === 'yes' || heart === 'no') out.heart = heart === 'yes';
    return out;
  }

  function findBy(nodes, attr, value) {
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute(attr) === value) return nodes[i];
    }
    return null;
  }

  customElements.define('engraving-personalizer', class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      var el = this;
      this.isCard = this.dataset.layout === 'card';
      this.maxLines = parseInt(this.dataset.maxLines, 10) || 3;
      this.maxChars = parseInt(this.dataset.maxChars, 10) || 15;
      this.variantSync = this.dataset.variantSync || '';
      this.sectionId = this.dataset.section || '';
      this.frontRequired = this.dataset.frontRequired !== 'false';
      // Opt-in: only with data-enforce-required="true" does variant sync make the back field required
      // (and does be-product-form.js block the add). No template sets it today.
      this.enforceRequired = this.dataset.enforceRequired === 'true';
      this.fieldAWrap = this.querySelector('[data-field="a"]');
      this.fieldBWrap = this.querySelector('[data-field="b"]');
      this.front = this.fieldAWrap ? this.fieldAWrap.querySelector('textarea') : null;
      this.back = this.fieldBWrap ? this.fieldBWrap.querySelector('textarea') : null;
      this.previewText = this.querySelector('[data-preview-text]');
      this.previewPlate = this.querySelector('[data-preview-plate]');
      this.previewShape = this.dataset.previewShape || 'plate';
      this.isProof = !this.isCard && this.previewShape !== 'plate';
      this.fontDropdown = this.querySelector('[data-font-dropdown]');
      this.previewFamily = 'Marcellus';
      this.fontValueInput = this.querySelector('[data-font-value]');
      this.fontValue = this.fontValueInput ? this.fontValueInput.value : '';

      // Card layout: Front/Back tabs, live caption.
      this.side = this.dataset.side === 'back' ? 'back' : 'front';
      this.syncVisible = { front: true, back: true };
      this.tablist = this.querySelector('[data-side-tabs]');
      this.tabs = this.querySelectorAll('[data-side-tab]');
      this.captionEl = this.querySelector('[data-engraving-caption]');
      // Line counter row (shown only inside the phone Personalize sheet).
      this.countLinesEl = this.querySelector('[data-count-lines]');
      this.countLongestEl = this.querySelector('[data-count-longest]');

      // Alignment + text size controls (optional in both layouts).
      this.layoutEl = this.querySelector('[data-engraving-layout]');
      this.alignBtns = this.querySelectorAll('[data-align-btn]');
      this.sizeBtns = this.querySelectorAll('[data-size-btn]');
      this.alignInput = this.querySelector('[data-align-value]');
      this.sizeInput = this.querySelector('[data-size-value]');
      this.layoutCaption = this.querySelector('[data-layout-caption]');
      var activeAlign = this.querySelector('[data-align-btn].is-active');
      var activeSize = this.querySelector('[data-size-btn].is-active');
      this.align = activeAlign ? activeAlign.getAttribute('data-align-btn') : 'left';
      this.size = activeSize ? activeSize.getAttribute('data-size-btn') : 'm';

      // 'fixed_tally' design (card layout): fixed line + date + tally marks on the front.
      var design = this.dataset.design;
      this.design = this.isCard && (design === 'fixed_tally' || design === 'fixed_heart') ? design : 'free';
      this.isFixed = this.design !== 'free';
      // Bottom-right corner of the fixed front: tally marks, or a name with an optional heart.
      this.corner = this.design === 'fixed_heart' ? 'heart' : 'tally';
      if (this.isFixed) this.initFixed();

      [this.front, this.back].forEach(function (ta) {
        if (!ta) return;
        ta.addEventListener('input', function () {
          var nameOnly = el.nameFront && ta === el.front;
          var clamped = clampText(ta.value, nameOnly ? 1 : el.maxLines, nameOnly ? el.nameMaxChars : el.maxChars);
          if (clamped !== ta.value) ta.value = clamped;
          el.updateCounter(ta);
          el.updatePreview();
          el.updateCaption();
          el.emit();
        });
        // A hidden (inactive-tab) textarea that fails validation: bring it into view.
        ta.addEventListener('invalid', function () {
          if (el.isCard) el.setSide(ta.dataset.engravingText);
        });
        el.updateCounter(ta);
      });

      // Variant-driven field visibility: recompute whenever a variant option changes.
      if (this.variantSync) {
        document.addEventListener('change', function (e) {
          if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
            el.applyVariantSync();
          }
        });
        this.applyVariantSync();
      }

      if (this.fontDropdown) this.initFonts();

      // Front/Back tabs (click + arrow keys).
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          el.setSide(tab.getAttribute('data-side-tab'));
        });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var next = el.side === 'front' ? 'back' : 'front';
          if (el.setSide(next)) {
            var t = findBy(el.tabs, 'data-side-tab', next);
            if (t) t.focus();
          }
        });
      });

      // A bound <engraving-preview> (Front/Back chips) can ask us to switch sides.
      if (this.isCard) {
        document.addEventListener('engraving:side-request', function (e) {
          var d = e.detail || {};
          if (String(d.sectionId) === String(el.sectionId)) el.setSide(d.side);
        });
      }

      this.alignBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { el.setAlign(btn.getAttribute('data-align-btn')); });
      });
      this.sizeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { el.setSize(btn.getAttribute('data-size-btn')); });
      });

      // Proof mode (round/rounded tags): refit text on resize and once webfonts settle.
      if (this.isProof) {
        var refit = function () { el.fitText(); };
        window.addEventListener('resize', refit);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(refit);
        }
      }

      this.applyParams(readParams());
      if (this.isCard) this.renderSides();
      this.updatePreview();
      this.updateCaption();

      this._ready = true;
      this.emit();
    }

    // ---- Fonts ---------------------------------------------------------------

    initFonts() {
      var el = this;
      var dd = this.fontDropdown;
      var trigger = dd.querySelector('[data-font-trigger]');
      var list = dd.querySelector('[data-font-list]');
      this.fontTrigger = trigger;
      this.fontTriggerLabel = dd.querySelector('[data-font-trigger-label]');
      this.fontList = list;
      this.fontChips = dd.querySelectorAll('[data-font-chip]');

      // Custom font dropdown (scrollable, capped height).
      var frag = document.createDocumentFragment();
      FONTS.forEach(function (f) {
        var li = document.createElement('li');
        li.className = 'engraving__font-option';
        li.setAttribute('role', 'option');
        li.dataset.value = 'Custom: ' + f;
        li.dataset.previewFont = f;
        li.textContent = f;
        li.style.fontFamily = "'" + f + "'";
        frag.appendChild(li);
      });
      list.appendChild(frag);

      var selOpt = list.querySelector('.engraving__font-option.is-selected') ||
        dd.querySelector('[data-font-chip].is-selected');
      if (selOpt) this.previewFamily = selOpt.dataset.previewFont || 'Marcellus';

      loadFonts(this.isCard ? ['Marcellus', 'Pinyon Script', 'EB Garamond'] : ['Marcellus', 'Pinyon Script']);
      var loadedAll = false;
      var openList = function () {
        if (!loadedAll) { loadedAll = true; loadFonts(FONTS); }
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      };
      var closeList = function () {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };
      this.closeFontList = closeList;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (list.hidden) openList(); else closeList();
      });
      list.addEventListener('click', function (e) {
        var li = e.target.closest('.engraving__font-option');
        if (!li) return;
        el.selectFont(li.dataset.value);
        closeList();
      });
      this.fontChips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          el.selectFont(chip.getAttribute('data-font-chip'));
          closeList();
        });
      });
      document.addEventListener('click', function (e) {
        if (!el.fontDropdown.contains(e.target)) closeList();
      });
      dd.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !list.hidden) {
          closeList();
          trigger.focus();
        }
      });
    }

    // Select a properties[Font] value. The hidden input is the single source of truth.
    // Returns false (and changes nothing) for values this picker does not offer.
    selectFont(value, silent) {
      if (!this.fontDropdown || !value) return false;
      var options = this.fontList.querySelectorAll('.engraving__font-option');
      var li = findBy(options, 'data-value', value);
      var chip = this.fontChips.length ? findBy(this.fontChips, 'data-font-chip', value) : null;
      if (!li && !chip) return false;

      options.forEach(function (o) { o.classList.toggle('is-selected', o === li); });
      this.fontValue = value;
      if (this.fontValueInput) this.fontValueInput.value = value;

      if (this.isCard) {
        this.fontChips.forEach(function (c) {
          c.classList.toggle('is-selected', c === chip);
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
        });
        var fromList = !chip;
        this.fontTrigger.classList.toggle('is-selected', fromList);
        this.fontTrigger.setAttribute('aria-pressed', fromList ? 'true' : 'false');
        this.fontTriggerLabel.textContent = fromList ? li.textContent : '100+ more';
        this.fontTriggerLabel.style.fontFamily = fromList ? li.style.fontFamily : '';
        this.previewFamily = (chip || li).dataset.previewFont || 'Marcellus';
      } else {
        this.fontTriggerLabel.textContent = li.textContent;
        this.fontTriggerLabel.style.fontFamily = li.style.fontFamily;
        this.previewFamily = li.dataset.previewFont || li.textContent;
      }

      loadFonts([this.previewFamily]);
      if (this.isFixed) this.updateFixedFont();
      this.updatePreview();
      if (!silent) this.emit();
      return true;
    }

    // ---- Sides (card layout) -------------------------------------------------

    sideAvailable(side) {
      var ta = side === 'back' ? this.back : this.front;
      return !!ta && this.syncVisible[side];
    }

    getSide() {
      if (this.isCard) return this.side;
      var p = this.primaryField();
      return p && p === this.back ? 'back' : 'front';
    }

    setSide(side, silent) {
      if (!this.isCard) return false;
      side = side === 'back' ? 'back' : 'front';
      if (!this.sideAvailable(side)) return false;
      if (side === this.side) return true;
      this.side = side;
      this.renderSides();
      this.updateCaption();
      if (!silent) this.emit();
      return true;
    }

    renderSides() {
      var avail = { front: this.sideAvailable('front'), back: this.sideAvailable('back') };
      if (!avail[this.side]) this.side = avail.front ? 'front' : 'back';
      var side = this.side;
      if (this.fieldAWrap) this.fieldAWrap.hidden = !(side === 'front' && avail.front);
      if (this.fieldBWrap) this.fieldBWrap.hidden = !(side === 'back' && avail.back);
      this.tabs.forEach(function (tab) {
        var s = tab.getAttribute('data-side-tab');
        var on = s === side;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        tab.hidden = !avail[s];
      });
      if (this.tablist) this.tablist.hidden = !(avail.front && avail.back);
      this.dataset.side = side;
    }

    updateCaption() {
      var ta = this.getSide() === 'back' ? this.back : this.front;
      var lines = ta && ta.value ? ta.value.split('\n') : [];
      var n = lines.filter(function (l) { return l.length; }).length;
      if (this.captionEl) {
        var fixedCaption = this.corner === 'heart'
          ? 'Your date and a name'
          : 'Your date and ' + this.tally + ' tally mark' + (this.tally === 1 ? '' : 's');
        this.captionEl.textContent = this.isFixed && this.getSide() === 'front'
          ? fixedCaption
          : n + ' of ' + this.maxLines + ' lines · ' + this.maxChars + ' chars each';
      }
      if (this.countLinesEl) this.countLinesEl.textContent = n + ' of ' + this.maxLines + ' lines';
      if (this.countLongestEl) {
        var longest = lines.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
        this.countLongestEl.textContent = 'Longest line ' + longest + ' / ' + this.maxChars;
      }
    }

    // ---- Alignment + size ----------------------------------------------------

    setAlign(align, silent) {
      align = normAlign(align);
      if (!align || !this.layoutEl) return false;
      this.align = align;
      this.alignBtns.forEach(function (b) {
        var on = b.getAttribute('data-align-btn') === align;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (this.alignInput) this.alignInput.value = ALIGN_LABEL[align];
      this.updateLayoutCaption();
      this.updatePreview();
      if (!silent) this.emit();
      return true;
    }

    setSize(size, silent) {
      size = normSize(size);
      if (!size || !this.layoutEl) return false;
      this.size = size;
      this.sizeBtns.forEach(function (b) {
        var on = b.getAttribute('data-size-btn') === size;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (this.sizeInput) this.sizeInput.value = SIZE_LABEL[size];
      this.updateLayoutCaption();
      if (!silent) this.emit();
      return true;
    }

    updateLayoutCaption() {
      if (this.layoutCaption) {
        this.layoutCaption.textContent = ALIGN_LABEL[this.align] + ' · ' + SIZE_LABEL[this.size];
      }
    }

    // ---- Prefill + state + event ---------------------------------------------

    applyParams(p) {
      if (!p) return;
      var el = this;
      [['front', this.front], ['back', this.back]].forEach(function (pair) {
        var ta = pair[1];
        if (!ta || typeof p[pair[0]] !== 'string') return;
        if (el.isFixed && pair[0] === 'front') return; // handled below
        ta.value = clampText(p[pair[0]], el.maxLines, el.maxChars);
        el.updateCounter(ta);
      });
      if (this.isFixed) {
        // front = "<fixed line>\n<date>": take the date only when line 1 is this design's line.
        if (typeof p.front === 'string' && this.dateInput) {
          var parts = p.front.replace(/\r/g, '').split('\n');
          if (parts[0].trim().toLowerCase() === this.fixedLine.trim().toLowerCase()) {
            var max = parseInt(this.dateInput.getAttribute('maxlength'), 10) || 20;
            this.dateInput.value = parts.slice(1).map(function (l) { return l.trim(); }).filter(Boolean).join(' ').slice(0, max);
          }
        }
        if (p.tally) this.setTally(p.tally, true);
        if (this.corner === 'heart') {
          if (typeof p.name === 'string') this.setName(p.name, true);
          if (typeof p.heart === 'boolean') this.setHeart(p.heart, true);
        }
        this.composeFront();
      }
      if (p.fontValue) this.selectFont(p.fontValue, true);
      if (p.align) this.setAlign(p.align, true);
      if (p.size) this.setSize(p.size, true);
      if (p.side && this.isCard && this.sideAvailable(p.side)) this.side = p.side;
    }

    // Put back a whole state (same shape as getState(): front, back, fontValue, align, size, side),
    // e.g. when the Personalize sheet is cancelled. Emits once.
    setState(p) {
      if (!p) return;
      this.applyParams(p);
      if (this.isCard) this.renderSides();
      this.updatePreview();
      this.updateCaption();
      this.emit();
    }

    getState() {
      var side = this.getSide();
      var ta = side === 'back' ? this.back : this.front;
      var lines = ta && ta.value ? ta.value.split('\n') : [];
      var fam = this.previewFamily;
      var isScript = SCRIPT_FONTS.indexOf(fam) !== -1;
      var date = this.isFixed && this.dateInput ? this.dateInput.value.trim() : '';
      var isHeart = this.isFixed && this.corner === 'heart';
      var name = isHeart && this.nameInput ? this.nameInput.value.trim() : '';
      var hasText = !!((this.front && this.front.value.trim()) || (this.back && this.back.value.trim()));
      return {
        design: this.design,
        tally: this.isFixed && !isHeart ? this.tally : null,
        date: date,
        name: name,
        heart: isHeart ? this.heart : null,
        // Ready to engrave: fixed designs need their date (and the corner name), free text needs any text.
        complete: this.isFixed ? !!date && (!isHeart || !!name) : hasText,
        sectionId: this.sectionId,
        layout: this.isCard ? 'card' : 'classic',
        front: this.front ? this.front.value : '',
        back: this.back ? this.back.value : '',
        fontValue: this.fontValue,
        fontFamily: fam,
        fontCss: "'" + fam + "', " + (isScript ? 'cursive' : 'serif'),
        fontScale: scaleFor(fam),
        align: this.align,
        size: this.size,
        side: side,
        lineCount: lines.filter(function (l) { return l.length; }).length,
        longestLine: lines.reduce(function (m, l) { return Math.max(m, l.length); }, 0),
        maxLines: this.maxLines,
        maxChars: this.maxChars,
        frontEnabled: !!(this.front && !this.front.disabled),
        backEnabled: !!(this.back && !this.back.disabled)
      };
    }

    emit() {
      if (!this._ready) return;
      document.dispatchEvent(new CustomEvent('engraving:change', { detail: this.getState() }));
    }

    // Optional client-side check (the Dawn product form is novalidate, so `required`
    // alone does not block submit). Switches to the offending tab and reports it.
    validate() {
      if (this.isFixed && this.dateInput && !this.dateInput.value.trim()) {
        this.setSide('front');
        this.dateInput.setCustomValidity('Add your date first.');
        this.dateInput.focus();
        if (this.dateInput.reportValidity) this.dateInput.reportValidity();
        return false;
      }
      if (this.isFixed && this.corner === 'heart' && this.nameInput && !this.nameInput.value.trim()) {
        this.setSide('front');
        this.nameInput.setCustomValidity('Add the name for the corner.');
        this.nameInput.focus();
        if (this.nameInput.reportValidity) this.nameInput.reportValidity();
        return false;
      }
      var fields = [this.front, this.back];
      for (var i = 0; i < fields.length; i++) {
        var ta = fields[i];
        if (ta && !ta.disabled && ta.required && !ta.value.trim()) {
          if (this.isCard) this.setSide(ta.dataset.engravingText);
          ta.focus();
          if (ta.reportValidity) ta.reportValidity();
          return false;
        }
      }
      return true;
    }

    // ---- Fixed design (fixed line + date + tally marks) ----------------------

    initFixed() {
      var el = this;
      this.fixedLine = this.dataset.fixedLine || '';
      this.dateInput = this.querySelector('[data-engraving-date]');
      this.tallyInput = this.querySelector('[data-tally-input]');
      this.tallyValue = this.querySelector('[data-tally-value]');
      this.fixedText = this.querySelector('[data-fixed-text]');
      this.tallySteps = this.querySelectorAll('[data-tally-step]');
      this.tallyMin = parseInt(this.dataset.tallyMin, 10) || 1;
      this.tallyMax = parseInt(this.dataset.tallyMax, 10) || 50;
      this.tally = this.clampTally(this.tallyInput ? this.tallyInput.value : 11);
      // be-product-form.js shows this when an add is blocked.
      this.dataset.requiredMessage = this.corner === 'heart'
        ? 'Add your date and name before adding this to your bag.'
        : 'Add your date before adding this to your bag.';
      if (this.corner === 'heart') this.initHeart();

      if (this.dateInput) {
        this.dateInput.addEventListener('input', function () {
          var v = el.dateInput.value.replace(/[\r\n]+/g, ' ');
          if (v !== el.dateInput.value) el.dateInput.value = v;
          el.dateInput.setCustomValidity('');
          el.composeFront();
          el.updateCaption();
          el.emit();
        });
      }
      if (this.tallyInput) {
        // Typing: follow valid numbers live, tidy up (clamp) when the field is left.
        this.tallyInput.addEventListener('input', function () {
          var n = parseInt(el.tallyInput.value, 10);
          if (n >= el.tallyMin && n <= el.tallyMax) el.setTally(n, false, true);
        });
        this.tallyInput.addEventListener('change', function () {
          el.setTally(el.tallyInput.value);
        });
      }
      this.tallySteps.forEach(function (btn) {
        btn.addEventListener('click', function () {
          el.setTally(el.tally + (parseInt(btn.getAttribute('data-tally-step'), 10) || 0));
        });
      });
      this.setTally(this.tally, true);
      this.composeFront();
    }

    // fixed_heart corner: a name (required) and a heart on / off.
    initHeart() {
      var el = this;
      this.nameInput = this.querySelector('[data-engraving-name]');
      this.nameValue = this.querySelector('[data-name-value]');
      this.heartValue = this.querySelector('[data-heart-value]');
      this.heartBtns = this.querySelectorAll('[data-heart-btn]');
      this.heart = !this.heartValue || this.heartValue.value !== 'No';
      if (this.nameInput) {
        this.nameInput.addEventListener('input', function () {
          var v = el.nameInput.value.replace(/[\r\n]+/g, ' ');
          if (v !== el.nameInput.value) el.nameInput.value = v;
          el.nameInput.setCustomValidity('');
          el.setName(v);
        });
      }
      this.heartBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          el.setHeart(btn.getAttribute('data-heart-btn') === 'yes');
        });
      });
      this.setName(this.nameInput ? this.nameInput.value : '', true);
      this.setHeart(this.heart, true);
    }

    setName(name, silent) {
      if (!this.nameInput) return;
      var max = parseInt(this.nameInput.getAttribute('maxlength'), 10) || 16;
      name = String(name || '').replace(/[\r\n]+/g, ' ').slice(0, max);
      if (this.nameInput.value !== name) this.nameInput.value = name;
      if (this.nameValue) this.nameValue.value = name.trim();
      if (!silent) this.emit();
    }

    setHeart(on, silent) {
      this.heart = !!on;
      var el = this;
      this.heartBtns.forEach(function (btn) {
        var active = (btn.getAttribute('data-heart-btn') === 'yes') === el.heart;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (this.heartValue) this.heartValue.value = this.heart ? 'Yes' : 'No';
      if (!silent) this.emit();
    }

    clampTally(n) {
      n = parseInt(n, 10);
      if (!(n >= this.tallyMin)) return this.tallyMin;
      return Math.min(this.tallyMax, n);
    }

    setTally(n, silent, typing) {
      if (!this.isFixed) return false;
      n = this.clampTally(n);
      this.tally = n;
      if (this.tallyValue) this.tallyValue.value = String(n);
      if (this.tallyInput && !typing && this.tallyInput.value !== String(n)) this.tallyInput.value = String(n);
      var el = this;
      this.tallySteps.forEach(function (btn) {
        var step = parseInt(btn.getAttribute('data-tally-step'), 10);
        btn.disabled = (step < 0 && n <= el.tallyMin) || (step > 0 && n >= el.tallyMax);
      });
      this.updateCaption();
      if (!silent) this.emit();
      return true;
    }

    // The order field: "<fixed line>" plus "\n<date>" once there is a date.
    composeFront() {
      if (!this.isFixed || !this.front) return;
      var date = this.dateInput ? this.dateInput.value.trim() : '';
      this.front.value = this.fixedLine + (date ? '\n' + date : '');
    }

    // Show the fixed line in the chosen font.
    updateFixedFont() {
      if (!this.fixedText) return;
      var fam = this.previewFamily || 'Marcellus';
      this.fixedText.style.fontFamily = "'" + fam + "', " + (SCRIPT_FONTS.indexOf(fam) !== -1 ? 'cursive' : 'serif');
    }

    // ---- Variant sync (unchanged behaviour) ----------------------------------

    findPicker() {
      return (this.sectionId && document.querySelector(
        'variant-selects[data-section="' + this.sectionId + '"], variant-radios[data-section="' + this.sectionId + '"]'
      )) || document.querySelector('variant-selects, variant-radios');
    }

    readVariant() {
      var picker = this.findPicker();
      if (!picker) return '';
      var vals = [];
      picker.querySelectorAll('select').forEach(function (s) { if (s.value) vals.push(s.value); });
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { if (r.value) vals.push(r.value); });
      return vals.join(' / ');
    }

    // Selected options as "Option name: value" (select name="options[Name]" / radio name="Name").
    readVariantPairs() {
      var picker = this.findPicker();
      if (!picker) return [];
      var pairs = [];
      picker.querySelectorAll('select').forEach(function (s) {
        var m = /^options\[(.*)\]$/.exec(s.name || '');
        if (m && s.value) pairs.push(m[1] + ': ' + s.value);
      });
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        if (r.name && r.value) pairs.push(r.name + ': ' + r.value);
      });
      return pairs;
    }

    applyVariantSync() {
      if (!this.variantSync) return;
      var vals = this.readVariant();
      var showA = true, showB = false;
      if (this.variantSync === 'back') {
        showA = !!this.front;
        showB = /both|back/i.test(vals);
      } else if (this.variantSync === 'in_out') {
        if (/both/i.test(vals)) { showA = true; showB = true; }
        else if (/outside/i.test(vals)) { showA = false; showB = true; }
        else { showA = true; showB = false; }
      }
      // data-as-pictured: this option is engraved exactly as the photo, so nothing to fill in.
      // data-back-only: the front is the pictured design, only the back takes text.
      // data-name-front: the front is only a name in the design's lettering.
      var asPictured = this.optionListed(this.dataset.asPictured, vals);
      var initialsFront = !asPictured && this.optionListed(this.dataset.initialsFront, vals);
      var nameFront = !asPictured && (initialsFront || this.optionListed(this.dataset.nameFront, vals));
      if (asPictured) { showA = false; showB = false; }
      else if (this.optionListed(this.dataset.backOnly, vals)) { showA = false; showB = !!this.back; }
      this.setFieldVisible(this.fieldAWrap, this.front, showA, this.frontRequired);
      this.setFieldVisible(this.fieldBWrap, this.back, showB, this.enforceRequired);
      this.setAsPictured(asPictured);
      this.setNameFront(nameFront ? (initialsFront ? 'initials' : 'name') : '', showB);
      // Font and preview: off for "as pictured", and for a name-only front with no back message.
      var noFont = asPictured || (nameFront && !showB);
      if (this.fontDropdown) this.fontDropdown.hidden = noFont;
      if (this.fontValueInput) this.fontValueInput.disabled = noFont;
      var fontLabel = this.querySelector('[data-font-label]');
      if (fontLabel) fontLabel.textContent = nameFront && showB ? 'Font for the back message' : 'Font';
      var preview = this.querySelector('.engraving__preview');
      if (preview) preview.hidden = noFont;
      if (this.isCard) {
        this.renderSides();
        this.updateCaption();
      }
      this.updatePreview();
      this.emit();
    }

    // True when a selected option is in `list` (pipe separated, any case), e.g. data-as-pictured. An item
    // is either a bare value ("Send As Shown") or "Option name: value" ("Engraving Options: Add Message to
    // Back") when the same value means something else on another product that shares the template.
    optionListed(list, vals) {
      var items = String(list || '').toLowerCase().split('|').map(function (v) { return v.trim(); }).filter(Boolean);
      if (!items.length) return false;
      var selected = String(vals || '').split(' / ').concat(this.readVariantPairs());
      return selected.some(function (v) { return items.indexOf(String(v).toLowerCase().trim()) !== -1; });
    }

    // Hide and switch off everything but the note: no text, no Font, no preview for "as pictured".
    setAsPictured(on) {
      this.asPictured = !!on;
      this.classList.toggle('is-as-pictured', this.asPictured);
      var note = this.querySelector('[data-as-pictured-note]');
      if (note) note.hidden = !this.asPictured;
      var head = this.querySelector('.engraving__head');
      if (head && this.dataset.asPictured) head.hidden = this.asPictured;
    }

    // Name-only front (data-name-front, or data-initials-front for initials): "Name" / "Initials" label,
    // one line, required (be-product-form.js blocks the add without it). Everything goes back to the
    // template's own label / placeholder when off. `kind`: 'name' | 'initials' | '' (off).
    setNameFront(kind, backShown) {
      if (!this.front) return;
      var hint = this.querySelector('.engraving__head .engraving__hint');
      if (!this._frontDefaults) {
        var label = this.querySelector('[data-front-label-text]');
        this._frontDefaults = {
          hint: hint ? hint.textContent : '',
          label: label ? label.textContent : '',
          placeholder: this.front.getAttribute('placeholder') || '',
          rows: this.front.getAttribute('rows') || '',
          enforce: this.dataset.enforceRequired || '',
          message: this.dataset.requiredMessage || ''
        };
      }
      var d = this._frontDefaults;
      var initials = kind === 'initials';
      var word = initials ? 'Initials' : 'Name';
      this.nameFront = !!kind;
      this.nameMaxChars = initials ? Math.min(10, this.maxChars) : this.maxChars;
      var labelEl = this.querySelector('[data-front-label-text]');
      if (labelEl) labelEl.textContent = this.nameFront ? word : d.label;
      if (hint && !this.isCard) {
        hint.textContent = !this.nameFront ? d.hint
          : word + ': one line, up to ' + this.nameMaxChars + ' characters' +
            (backShown ? ' · back message: ' + this.maxLines + ' lines' : '');
      }
      this.front.setAttribute('placeholder', this.nameFront ? (initials ? 'e.g. J&K' : 'e.g. Emma') : d.placeholder);
      if (this.nameFront) this.front.setAttribute('rows', '1');
      else if (d.rows) this.front.setAttribute('rows', d.rows);
      if (this.nameFront) {
        var one = this.front.value.split('\n')[0].slice(0, this.nameMaxChars);
        if (one !== this.front.value) this.front.value = one;
        this.front.required = !this.front.disabled;
        this.dataset.enforceRequired = 'true';
        this.dataset.requiredMessage = initials
          ? 'Add your initials before adding this to your bag.'
          : 'Add the name before adding this to your bag.';
      } else {
        this.dataset.enforceRequired = d.enforce;
        if (d.message) this.dataset.requiredMessage = d.message;
        else delete this.dataset.requiredMessage;
      }
      this.updateCounter(this.front);
    }

    setFieldVisible(wrap, ta, visible, requiredWhenVisible) {
      if (!wrap || !ta) return;
      if (this.isCard) {
        // Tabs own wrap.hidden in the card layout; renderSides() applies this.
        this.syncVisible[ta.dataset.engravingText] = visible;
      } else {
        wrap.hidden = !visible;
      }
      ta.disabled = !visible;
      ta.required = !!(visible && requiredWhenVisible);
    }

    // ---- Classic preview + counters (unchanged behaviour) ---------------------

    updateCounter(ta) {
      var counter = this.querySelector('[data-counter-for="' + ta.dataset.engravingText + '"]');
      if (!counter) return;
      var lines = ta.value ? ta.value.split('\n').length : 0;
      var max = this.nameFront && ta === this.front ? 1 : this.maxLines;
      counter.textContent = lines + '/' + max + ' lines';
    }

    primaryField() {
      // Name-only front: the preview shows the back message (the part whose font is chosen).
      if (this.nameFront && this.back && !this.back.disabled) return this.back;
      if (this.front && !this.front.disabled) return this.front;
      if (this.back && !this.back.disabled) return this.back;
      return this.front || this.back;
    }

    updatePreview() {
      if (!this.previewText) return;
      var src = this.primaryField();
      var text = src ? src.value : '';
      this.previewText.style.fontFamily = "'" + this.previewFamily + "', cursive";
      // Flat plate only: honour the alignment control when it is rendered.
      if (this.layoutEl && !this.isProof) this.previewText.style.textAlign = this.align;

      if (!text) {
        this.previewText.innerHTML = this.isProof
          ? '<div class="engraving__pv-line is-primary">Your text</div>'
          : '<div>Your text here</div>';
        if (this.isProof) this.fitText();
        return;
      }

      // First line is the headline (e.g. the pet's name); later lines are supporting
      // detail (phone number, etc.) and render smaller, like a real engraving proof.
      this.previewText.innerHTML = text.split('\n').map(function (l, i) {
        var div = document.createElement('div');
        div.className = 'engraving__pv-line' + (i === 0 ? ' is-primary' : '');
        div.textContent = l || ' ';
        return div.outerHTML;
      }).join('');

      if (this.isProof) {
        var self = this;
        this.fitText();
        // Re-fit after the chosen webfont swaps in (metrics change on load).
        setTimeout(function () { self.fitText(); }, 120);
      }
    }

    // Engraving proof: each line is sized independently to fill ~85% of the tag
    // width, so a short name renders large and a longer phone number renders
    // smaller underneath. A second pass scales everything down if the stacked
    // lines would exceed 85% of the tag height.
    fitText() {
      var plate = this.previewPlate, block = this.previewText;
      if (!plate || !block) return;
      var lines = block.querySelectorAll('.engraving__pv-line');
      if (!lines.length) return;

      var cfg = FIT[this.previewShape] || FIT.round;
      var fillByLine = cfg.w;
      var W = plate.clientWidth, availH = plate.clientHeight * cfg.h;

      var sizes = [];
      lines.forEach(function (line, i) {
        line.style.fontSize = '100px';
        var w = line.scrollWidth;
        if (!w) { sizes[i] = 10; return; }
        var availW = W * (fillByLine[i] || fillByLine[fillByLine.length - 1]);
        // Fill the width; cap so a 1-2 char line can't grow taller than the tag.
        sizes[i] = Math.max(10, Math.min(100 * (availW / w), availH));
      });

      // Cap line 3+ at line 2's size, so a short last line (e.g. 2 letters under
      // a name + phone number) doesn't balloon larger than the line above it.
      if (sizes.length > 2) {
        for (var i = 2; i < sizes.length; i++) {
          sizes[i] = Math.min(sizes[i], sizes[1]);
        }
      }

      lines.forEach(function (line, i) { line.style.fontSize = sizes[i] + 'px'; });

      var totalH = block.scrollHeight;
      if (totalH > availH) {
        var k = availH / totalH;
        lines.forEach(function (line) {
          line.style.fontSize = (parseFloat(line.style.fontSize) * k) + 'px';
        });
      }
    }
  });
})();
